import React from 'react';
import { useStepHeader } from './StepHeader.hooks';
import {
  StepHeaderContainer,
  StepHeaderBorder,
  StepHeaderIcon,
  StepHeaderTitle,
  StepHeaderDescription,
} from './StepHeader.styles';

export interface StepHeaderProps {
  currentStep: number;
  totalSteps?: number;
  variant?: 'default' | 'small' | 'large';
  showDescription?: boolean;
  className?: string;
}

const StepHeader: React.FC<StepHeaderProps> = ({
  currentStep,
  totalSteps = 3,
  showDescription = false,
  className,
}) => {
  const { currentStepConfig, isValidStep } = useStepHeader({
    currentStep,
    totalSteps,
  });

  if (!isValidStep || !currentStepConfig) {
    return null;
  }

  const accent = currentStepConfig.color;

  return (
    <StepHeaderContainer accentColor={accent} className={className}>
      <StepHeaderBorder accentColor={accent} />
      <StepHeaderIcon accentColor={accent}>{currentStepConfig.icon}</StepHeaderIcon>
      <div>
        <StepHeaderTitle>{currentStepConfig.title}</StepHeaderTitle>
        {showDescription && currentStepConfig.description ? (
          <StepHeaderDescription>{currentStepConfig.description}</StepHeaderDescription>
        ) : null}
      </div>
    </StepHeaderContainer>
  );
};

export default StepHeader;
